module.exports = __webpack_public_path__ + "img/carteirinhaCaoFrente_4.0d180f0c.jpeg";